export default __webpack_public_path__ + "mail.c0aee7f6.svg";